import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'ShareIcon',
  viewBox: '0 0 16 16',
  defaultProps: {
    boxSize: 4,
  },
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.4 4.4a.6.6 0 0 0-.6.6v6.8a.6.6 0 0 0 .6.6h6.8a.6.6 0 0 0 .6-.6V8.6a.6.6 0 1 1 1.2 0v3.2a1.8 1.8 0 0 1-1.8 1.8H3.4a1.8 1.8 0 0 1-1.8-1.8V5a1.8 1.8 0 0 1 1.8-1.8h4a.6.6 0 0 1 0 1.2z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.955 10.202a.6.6 0 0 0 .847.043L13.2 3.552V5.8a.6.6 0 1 0 1.2 0V2.2a.6.6 0 0 0-.6-.6h-3.6a.6.6 0 0 0 0 1.2h2.042L4.997 9.355a.6.6 0 0 0-.042.847"
        fill="currentColor"
      />
    </>
  ),
});
